import React from "react";
import "./Savol.css";
function Savol({ matn, currentNumber, total, solvedData, onSelect, maxUnlockedIndex }) {
  // Generate a fresh array from 0 to total-1
  const tartib = Array.from({ length: total || 40 }, (_, i) => i);

  return (
    <div className="masala-savol-quti">
      <div className="masala-savol-tartib">
        {tartib.map((qiymat) => {
          const isSolved = solvedData && solvedData[qiymat];
          const timeTaken = isSolved ? isSolved.vaqt : null;

          // Logic: unlocked if index <= maxUnlockedIndex OR if it's already solved (just in case logic differs)
          const isLocked = qiymat > (maxUnlockedIndex !== undefined ? maxUnlockedIndex : 9999);

          return (
            <span
              className={`${currentNumber === qiymat + 1 ? "faol" : ""} ${isSolved ? "yechilgan" : ""} ${isLocked ? "kilitlangan" : ""}`}
              key={qiymat}
              title={isLocked ? "Hali ochilmagan" : (timeTaken ? `Sarflangan vaqt: ${timeTaken} soniya` : "")}
              style={{
                position: 'relative',
                cursor: isLocked ? 'not-allowed' : 'pointer',
                opacity: isLocked ? 0.5 : 1
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!isLocked && onSelect) onSelect(qiymat);
              }}
            >
              {qiymat + 1}
              {/* Optional: Add a small checkmark or indicator if passed, but color might be enough */}
            </span>
          );
        })}
      </div>
      <div className="masala-savol">
        {matn}
        <br />
        <b>Izoh: Javobni chiqarish uchun chop() funksiyasidan foydalaning.</b>
      </div>
    </div>
  );
}

export default Savol;
